module.exports = __webpack_public_path__ + "img/purple-gradient-box.eb65ff8.svg";